module.exports = __webpack_public_path__ + "static/media/flag-solid-red-d71b12.4dc4b9dc.svg";